export function isModified(values: any): boolean {
  return Object.values(values).some((value) => value !== undefined && value !== null && value !== '');
}
